import moment from 'moment';
import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getPropertyValue } from '../settings';
import { ChatItem } from './components';
import { getMessageByUid } from './functions';
import { getLocalMemberRole, ROLE } from '../members';
import { useTranslation } from 'react-i18next';
const ChatItemContainer = React.memo(({ uuid }) => {
    const message = useSelector((state) => getMessageByUid(state, uuid), shallowEqual);
    if (!message)
        return null; // 조기 반환 시 명시적으로 null을 반환하도록 수정
    return React.createElement(ChatRenderContainer, { message: message });
});
export default ChatItemContainer;
export const ChatRenderContainer = React.memo(({ message }) => {
    const { t } = useTranslation();
    const militaryTime = useSelector((state) => getPropertyValue(state, 'militaryTime'));
    const localRole = useSelector((state) => getLocalMemberRole(state));
    const time = useMemo(() => (militaryTime ? moment(message.timestamp).format('HH:mm') : moment(message.timestamp).format('LT')), [militaryTime, message.timestamp]);
    const from = useMemo(() => {
        if (message.fromRole === 'admin' && localRole !== ROLE.ADMIN) {
            return t('role.admin');
        }
        // 진행자(manager)는 전 영역 실명 마스킹 — 발신자 본인 화면 포함 '조교'로 표기
        if (message.fromRole === ROLE.MANAGER) {
            return t('role.assistant');
        }
        return message.fromNickname?.split('(')[0] || '';
    }, [message.fromNickname, message.fromRole, localRole]);
    return (React.createElement(ChatItem, { wholeMessage: message, from: from, type: message.type, message: message.message, isMe: message.isMe, fromRole: message.fromRole, uuid: message.uuid, time: time, timestamp: message.timestamp }));
});
